var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.authorized
    ? _c(
        "div",
        { staticClass: "library-inventory" },
        [
          _c("DxLoadPanel", {
            attrs: {
              visible: _vm.isLoadIndicatorVisible,
              "shading-color": "rgba(0,0,0,0.4)",
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "library-inventory-header" }, [
            _c("h1", { staticClass: "wk_headline" }, [
              _vm._v(_vm._s(_vm.translationKeywords.Lib_Inv_Header)),
            ]),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                "\n            Sie haben die Möglichkeit eine Liste von ISBNs einzugeben. Das System generiert automatisch die notwendigen bibliographischen Angaben mit der Option, diese in Ihre Hausbibliothek zu übertragen!\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "search-by-isbn" },
            [
              _c("label", [
                _vm._v(_vm._s(_vm.translationKeywords.Lib_Inv_SearchByISBN)),
              ]),
              _vm._v(" "),
              _c("DxTextArea", {
                attrs: {
                  height: 90,
                  "element-attr": _vm.textAreaClass,
                  "show-borders": true,
                },
                on: { "value-changed": _vm.getISBN },
              }),
              _vm._v(" "),
              _c("DxButton", {
                attrs: {
                  type: "default",
                  "element-attr": _vm.searchButton,
                  text: _vm.translationKeywords.Lib_Inv_Search,
                },
                on: { click: _vm.searchByISBN },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "DxPopup",
            {
              staticClass: "inventory-departments-popup",
              attrs: {
                visible: _vm.isPopupVisible,
                title: _vm.translationKeywords.Lib_Inv_Departments,
                height: "200",
                width: "400",
              },
            },
            [
              [
                _c(
                  "div",
                  { staticClass: "dx-field-value" },
                  [
                    _c("DxSelectBox", {
                      attrs: {
                        "search-enabled": true,
                        items: _vm.departments,
                        "display-expr": "name",
                        placeholder:
                          _vm.translationKeywords.Lib_Inv_ChooseDepartment,
                        onSelectionChanged: _vm.onDepartmentChanged,
                      },
                      model: {
                        value: _vm.selectedDepartment,
                        callback: function ($$v) {
                          _vm.selectedDepartment = $$v
                        },
                        expression: "selectedDepartment",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("DxButton", {
                  attrs: {
                    type: "default",
                    text: _vm.translationKeywords.Lib_Inv_Import,
                    disabled: !_vm.importActivationBtn,
                  },
                  on: { click: _vm.importToLibary },
                }),
              ],
              _vm._v(" "),
              _c("DxToolbarItem", {
                attrs: {
                  options: _vm.closePopup,
                  widget: "dxButton",
                  location: "after",
                },
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "b-alert",
            {
              attrs: {
                show: _vm.notFoundList.length > 0,
                dismissible: "",
                variant: "danger",
              },
            },
            [
              _c("h5", [
                _vm._v(_vm._s(_vm.translationKeywords.Lib_Inv_Alert_Header)),
              ]),
              _vm._v(" "),
              _c(
                "p",
                { staticClass: "notFoundList" },
                [
                  _c("span", { staticClass: "mr-2 font-weight-bold" }, [
                    _vm._v("The next ISBNs can not be found"),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.notFoundList, function (isbn) {
                    return _c("span", { staticClass: "isbn-item" }, [
                      _vm._v(_vm._s(isbn)),
                    ])
                  }),
                ],
                2
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { id: "data-grid-demo" } },
            [
              _c(
                "DxDataGrid",
                {
                  attrs: {
                    "data-source": _vm.dataSource,
                    "on-initialized": _vm.onInitialized,
                    "row-alternation-enabled": true,
                    "show-borders": true,
                    "allow-column-resizing": true,
                    "key-expr": "productReference",
                    height: "300",
                    noDataText:
                      _vm.translationKeywords.Lib_Inv_ThereIsNoProducts,
                  },
                  on: { "selection-changed": _vm.onSelectionChanged },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "av-cell",
                        fn: function ({ data }) {
                          return [
                            _c("span", {
                              domProps: {
                                textContent: _vm._s(_vm.getStatus("Available")),
                              },
                            }),
                          ]
                        },
                      },
                      {
                        key: "grid-cell",
                        fn: function ({ data }) {
                          return [
                            _c("DxButton", {
                              attrs: {
                                type: "default",
                                "element-attr": _vm.buttonImport,
                                text: _vm.translationKeywords.Lib_Inv_Import,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.onResumeRow(data)
                                },
                              },
                            }),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3051060971
                  ),
                },
                [
                  _c("DxPaging", { attrs: { enabled: false } }),
                  _vm._v(" "),
                  _c("DxColumn", {
                    attrs: {
                      width: 150,
                      "data-field": "productReference",
                      caption:
                        _vm.translationKeywords.Lib_Inv_ProductReferrence,
                    },
                  }),
                  _vm._v(" "),
                  _c("DxColumn", {
                    attrs: {
                      "data-field": "distinctiveTitle",
                      caption: _vm.translationKeywords.Lib_Inv_DistinctiveTitle,
                    },
                  }),
                  _vm._v(" "),
                  _c("DxColumn", {
                    attrs: {
                      "data-field": "editionStatement",
                      caption: _vm.translationKeywords.Lib_Inv_EditionStatement,
                    },
                  }),
                  _vm._v(" "),
                  _c("DxColumn", {
                    attrs: {
                      "data-field": "publishers",
                      "data-type": "date",
                      caption: _vm.translationKeywords.Lib_Inv_Publishers,
                    },
                  }),
                  _vm._v(" "),
                  _c("DxColumn", {
                    attrs: {
                      width: 170,
                      "data-field": "price.priceSummary",
                      caption: _vm.translationKeywords.Lib_Inv_Price,
                    },
                  }),
                  _vm._v(" "),
                  _c("DxColumn", {
                    attrs: {
                      "data-field": "availability",
                      "data-type": "date",
                      caption: _vm.translationKeywords.Lib_Inv_Availability,
                      "cell-template": "av-cell",
                    },
                  }),
                  _vm._v(" "),
                  _c("DxColumn", {
                    attrs: {
                      width: 150,
                      visible: true,
                      "cell-template": "grid-cell",
                    },
                  }),
                  _vm._v(" "),
                  _vm._v(" "),
                  _vm._v(" "),
                  _c("DxPaging", { attrs: { "page-size": 10 } }),
                  _vm._v(" "),
                  _c("DxSelection", {
                    attrs: {
                      mode: "multiple",
                      deferred: true,
                      "select-all-mode": "allPages",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("DxButton", {
                attrs: {
                  type: "default",
                  "element-attr": _vm.ResumeAll,
                  disabled: !_vm.resumeAllStatus,
                  text: _vm.translationKeywords.Lib_Inv_ImportSelected,
                },
                on: { click: _vm.onResumeAll },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }